import styled from 'styled-components';
import { AllieDateRangePicker } from '../../../components/DateRangePicker/DateRangePicker';
import { AllieChip } from '../../../components/Chip/Chip';

const namespace = 'date-range-filter';

export const StyledDateRangeFilter = styled(AllieDateRangePicker)<{
  isMobile: boolean;
  toLeft?: boolean;
}>`
  .rdrStaticRangeLabel {
    color: var(--allie-color-neutral-70);
  }

  .rdrStaticRangeSelected {
    background-color: var(--allie-color-primary-20);
    font-weight: 400 !important;
  }

  &.rdrDateRangePickerWrapper {
    border: ${({ isMobile }) => (isMobile ? 'none' : 'solid 0.1px gray')};
    ${({ toLeft }) => (toLeft ? 'position: absolute; left: -300px' : '')};
    width: ${({ isMobile }) => isMobile && '100%'};
    display: ${({ isMobile }) => (isMobile ? 'flex' : 'inline-flex')};
  }

  .rdrCalendarWrapper {
    margin-left: ${({ isMobile }) => (isMobile ? 0 : '-50px')};
    width: ${({ isMobile }) => isMobile && '100%'};
  }

  .rdrDefinedRangesWrapper {
    display: ${({ isMobile }) => isMobile && 'none'};
  }

  .rdrMonth {
    width: ${({ isMobile }) => isMobile && '100%'};
    padding: ${({ isMobile }) => isMobile && 0};
  }
`;

export const StyledDateRangeContainer = styled.div<{ isMobile: boolean; fullWidth?: boolean }>`
  display: flex;
  position: relative;
  width: ${({ isMobile, fullWidth }) => (isMobile || fullWidth ? '100%' : '230px')};
`;

export const StyledDateRangeContent = styled.div<{ isMobile?: boolean }>`
  position: ${({ isMobile }) => (isMobile ? 'relative' : 'absolute')};
  z-index: 999;
  width: 100%;
`;

export const StyledDateRangeSelect = styled.div<{ fullWidth?: boolean }>`
  .${namespace}__label {
    display: flex;
    align-items: center;
    margin-right: 10px;
    font-weight: 400;
  }

  .${namespace}__container-item {
    display: flex;
    flex-wrap: wrap;
    row-gap: 10px;
    column-gap: 10px;
    flex-grow: 1;
  }

  .${namespace}__item {
    align-self: center;
    height: fit-content;
    display: flex;
    align-items: center;
    background: #ffffff;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    padding-left: 20px;
    border: 1px solid var(--allie-color-light-40);
    max-width: ${({ fullWidth }) => (fullWidth ? 'none' : '232px')};
    width: 100%;
    justify-content: space-between;
    box-sizing: border-box;

    &__select {
      border: none;
      font-weight: 400;
      font-size: 12px;

      &::part(icon) {
        color: var(--allie-color-primary-50);
        opacity: 1;
      }
    }
  }

  .${namespace}__label {
    margin-right: 10px;
  }
`;

export const FilterButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--allie-spacing-xs);
  margin-bottom: var(--allie-spacing-md);
`;

export const FilterButtonChip = styled(AllieChip)<{ isSelected: boolean }>`
  margin: 0;
  cursor: pointer;
`;
